import { get } from "lodash";

// Concatenates multiple items into a comma separated list
export default (items: any[], dataPath: string) => {
  const res = items.map((item) => get(item, dataPath, ``));

  return res.join(`, `);
};
